import { gql } from '@apollo/client';

export const GET_BRAND_BUSINESS_PROVIDER = gql`
	query GetBrandBusinessProvider($id: String!, $expoEventId: String) {
		brandBusinessServiceProvider(id: $id, expoEventId: $expoEventId) {
			id
			testimonial_1
			testimonial_2
			testimonial_3
			author1_name
			author1_company
			author2_name
			author2_company
			author3_name
			author3_company
			client_1_logo
			client_2_logo
			client_3_logo
			client_4_logo
			client_5_logo
			main_service_1
			main_service_2
			main_service_3
			main_service_4
			main_service_5
			reg_badge_number
			services_logo
			services_story
			sp_collat_1
			sp_collat_1_link
			sp_collat_2
			sp_collat_2_link
			sp_contact_1_email
			sp_contact_1_name
			sp_contact_1_number
			sp_contact_1_title
			sp_contact_2_email
			sp_contact_2_name
			sp_contact_2_number
			sp_contact_2_title
			sp_contact_3_email
			sp_contact_3_name
			sp_contact_3_number
			sp_contact_3_title
			subcategories_1
			subcategories_2
			subcategories_3
			subcategories_4
			subcategories_5
			common_data {
				boothNumber
				brand_attributes
				brand_country
				brand_facebook
				brand_foundation_year
				brand_instagram
				brand_linkedin
				brand_mission
				brand_state
				brand_story
				brand_tiktok
				brand_twitter
				brand_website
				brand_youtube
				brand_zip
				brokers {
					name
					phone
					email
				}
				contact_email
				contact_name
				contact_phone
				contact_title
				distributors
				holding_company
				parent_company
				how_its_made
				hq_city
				hq_country
				hq_state
				marketing_assets
				name
				url_logo
				uses_private_label
				prod_rep {
					name
					phone
					email
					title
				}
			}
		}
	}
`;
